export var rtcVersion = '9.9.2';
//# sourceMappingURL=version.js.map